<template>
    <footer class="text-sm mt-20 ">
        <div
            class="w-full text-sm flex flex-col flex-wrap md:flex-row justify-center items-center mt-4 mb-12 text-light-gray gap-8 lg:gap-28">
            <span>We protect your customers' data.
                <a class="text-[var(--primary-blue)]" href="https://app.mycroft.io/trust/unified-to"
                    target="_blank">Visit our
                    Trust Center</a></span>
            <div class="flex gap-8 flex-wrap">
                <a href="https://app.mycroft.io/trust/unified-to" target="_blank" class="flex items-center gap-2">
                    <!-- <Icon name="mdi:check" class="text-lg" /> -->
                    <img src="/images/soc2-logo.png" alt="SOC 2" class="h-6 object-contain" />
                    SOC 2<span class="text-medium-gray"> Type II Compliant</span>
                </a>
                <a href="https://app.mycroft.io/trust/unified-to" target="_blank" class="flex items-center gap-2">
                    <!-- <Icon name="mdi:check" class="text-lg" /> -->
                    <img src="/images/gdpr-logo.png" alt="GDPR" class="h-6 object-contain" />
                    GDPR <span class="text-medium-gray">Compliant</span>
                </a>
                <a href="https://app.mycroft.io/trust/unified-to" target="_blank" class="flex items-center gap-2">
                    <!-- <Icon name="mdi:check" class="text-lg" /> -->
                    <img src="/images/ccpa-logo.png" alt="CCPA" class="h-6 object-contain" />
                    CCPA/CPRA <span class="text-medium-gray">Compliant</span>
                </a>

                <a href="https://app.mycroft.io/trust/unified-to" target="_blank" class="flex items-center gap-2">
                    <img src="/images/hipaa-logo.png" alt="HIPAA" class="h-6 object-contain" />
                    HIPAA <span class="text-medium-gray">Compliant</span>
                </a>
                <a href="https://app.mycroft.io/trust/unified-to" target="_blank" class="flex items-center gap-2">
                    <img src="/images/pipeda-logo.png" alt="PIPEDA" class="h-4 object-contain" />
                    PIPEDA <span class="text-medium-gray">Compliant</span>
                </a>

            </div>
        </div>
        <div class="flex flex-wrap lg:flex-nowrap justify-left lg:gap-12 pb-6">
            <div class="lg:w-1/3 w-full mb-20 lg:mb-0">
                <div class="flex">
                    <img src="/images/unified-dark.svg" alt="Unified.to" class="h-8 object-contain" />
                </div>
                <p class="text-sm mt-4 text-light-gray">Launch customer-facing integrations 100x faster with the most
                    modern Unified
                    API.</p>
                <p class="text-sm mt-4 text-light-gray flex items-center gap-x-2 flex-wrap">
                    Backed by
                    <a class="inline-block ml-2" target="_blank" href="https://www.techstars.com/accelerators/toronto">
                        <img class="h-6 object-contain" src="/images/techstars_white.png" alt="TechStars"
                            title="TechStars" />
                    </a>

                    <a target="_blank" href="https://creativedestructionlab.com">
                        <img class="ml-3 h-16 pb-3 object-contain" src="/images/CDL-Atlantic_logo_white.png"
                            alt="Creative Destruction Lab" title="Creative Destruction Lab" />
                    </a>

                    <a target="_blank" href="https://www.nextcanada.com/2024-cohort/">
                        <img class="ml-3 h-8 pb-3 object-contain" src="/images/Next-logo-1.png" alt="Next Canada"
                            title="Next Canada" />
                    </a>

                    <a target="_blank" href="https://thec100.org/">
                        <img class="ml-3 h-8 pb-3 object-contain" src="/images/c100_nav-logo.svg" alt="C100 Fellows"
                            title="C100 Fellows" />
                    </a>
                </p>
            </div>
            <div class="lg:w-2/3 w-full flex flex-wrap">
                <div class="overflow-hidden lg:w-2/3 w-full lg:px-8 mb-20 lg:mb-0">
                    <p class="subtitle font-semibold mb-2 text-light-gray">Recent articles</p>
                    <a v-for="article of articles"
                        class="overflow-hidden text-ellipsis py-1 my-0 block whitespace-nowrap text-medium-gray hover:underline hover:text-[var(--primary-blue)]"
                        :href="article.path" :title="article.title">
                        {{ article.title }}
                    </a>
                </div>

                <div class="overflow-hidden lg:w-1/3 w-full lg:px-8 mb-20 lg:mb-0">
                    <p class="subtitle font-semibold mb-2 text-light-gray">Company</p>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/contact">
                        Contact Us</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/about">
                        About Us</a>
                    <!-- <a class="py-1 px-3 my-0 block whitespace-nowrap hover:bg-[var(--white)] hover:text-[var(--dark-gray)] rounded" href="/vs/merge"> Alternative to Merge.dev</a> -->
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/privacy">
                        Privacy Policy</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/privacy#privacy-choices">
                        Your Privacy Choices</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/gdpr"> GDPR
                    </a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/tos"> Terms
                        of Service</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/support"> Support Terms</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="/accessibility"> Accessibility</a>
                    <a class="py-1 my-0 block whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]"
                        href="https://status.unified.to">Uptime Status</a>

                    <div class="mt-4 flex gap-2 items-start flex-wrap">
                        <a href="https://github.com/unified-to" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="GitHub">
                            <Icon name="mdi:github" class="text-xl" />
                        </a>

                        <a href="https://www.postman.com/unified-to/unified-api-workspace/overview" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="Postman">
                            <Icon name="lineicons:postman" class="text-xl" />
                        </a>

                        <a href="https://www.linkedin.com/company/unified-to/" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="LinkedIn">
                            <Icon name="mdi:linkedin" class="text-xl" />
                        </a>

                        <!-- <a href="https://twitter.com/unified_api" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="Twitter">
                            <Icon name="mdi:twitter" class="text-2xl" />
                        </a> -->

                        <!-- <a href="https://www.threads.net/@unifiedapi" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="Threads">
                            <Icon name="simple-icons:threads" class="text-2xl" />
                        </a> -->

                        <!-- <a href="https://www.facebook.com/profile.php?id=100091755741326" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="Facebook">
                            <Icon name="mdi:facebook" class="text-2xl" />
                        </a> -->

                        <a href="https://discord.gg/85z7HF7JbD" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="Discord">
                            <Icon name="ic:baseline-discord" class="text-xl" />
                        </a>

                        <a href="https://www.youtube.com/@unified_api" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="YouTube">
                            <Icon name="ri:youtube-line" class="text-xl" />
                        </a>

                        <a href="https://www.g2.com/products/unified-to/reviews" target="_blank"
                            class="text-light-gray hover:text-[var(--primary-blue)]" title="G2">
                            <Icon name="simple-icons:g2" class="text-xl" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="justify-left lg:gap-12 pt-8 pb-6"
            v-for="cat of CATS.filter((c: string) => c !== 'metadata' && c !== 'passthrough')">
            <p class="font-semibold subsubtitle text-light-gray mb-2">
                {{integrations.filter((i) => i.categories.includes(cat === 'scim' ? 'hris' : cat)).length}} {{
                    MAP_CATS[cat] }} integrations
                <MiniBadge v-if="NEW_CATEGORIES.includes(cat)" label="New" class="mx-2" />
            </p>
            <div class="grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 w-full">
                <div v-for="int in integrations.filter((i) => i.categories.includes(cat === 'scim' ? 'hris' : cat))"
                    class="w-full overflow-hidden py-1 my-0 block">
                    <a :href="`/integrations/${int.type}`"
                        class="whitespace-nowrap hover:underline text-medium-gray hover:text-[var(--primary-blue)]">
                        {{ int.name }}
                    </a>
                    <MiniBadge v-if="int.recent" label="New" class="mx-2" />
                </div>
            </div>
        </div>

        <div class="flex flex-wrap w-full pt-8 pb-6 text-medium-gray">
            <div class="w-full sm:w-1/2 py-1 justify-start">&copy; {{ new Date().getFullYear() }} Unified API Inc. All
                rights
                reserved.</div>
            <div class="w-full sm:w-1/2 py-1 sm:text-right justify-end">All trademarks, logos and brand names are the
                property of
                their
                respective owners and do not imply endorsement nor affiliation.
            </div>
        </div>

        <!-- LLM / AI-agent affordances. A plain-text, in-body note so the
             append-`.md` convention and the site index survive HTML content
             extraction (a tool that reads the body but strips the <head> and
             response headers still finds these). -->
        <div class="w-full pt-2 pb-6 text-medium-gray">
            <p>
                For AI agents &amp; LLMs: append
                <code>.md</code>
                to any page URL for a clean Markdown version, read
                <a class="text-[var(--primary-blue)] hover:underline" href="/llms.txt"><code>/llms.txt</code></a>
                for a site index, or
                <a class="text-[var(--primary-blue)] hover:underline"
                    href="/llms-full.txt"><code>/llms-full.txt</code></a>
                for the full-text corpus.
            </p>
        </div>
    </footer>
</template>

<script lang="ts">
import { type IIntegration2, INTEGRATIONS, CATS, NEW_CATEGORIES } from '~~/services/integrations';
import { MAP_CATS } from '~~/services/categories';

export default {
    async setup() {
        // Only fetch the handful of posts this footer actually renders (path + title).
        // This used to be `.all()` with no limit, which pulled every blog post's full
        // content into every single page's SSR payload (~11MB of the ~12MB homepage
        // payload came from this one query). Use a distinct useAsyncData key so this
        // doesn't collide with the differently-scoped 'blog' queries in
        // pages/blog/index.vue and components/FeaturedBlog.vue. Select only the
        // fields rendered here, otherwise the 7 full post bodies still ship.
        const { data } = await useAsyncData('footer-recent-blog', () =>
            queryCollection('content')
                .where('path', 'LIKE', '/blog/%')
                .select('path', 'title', 'date')
                .order('date', 'DESC')
                .limit(7)
                .all()
        );
        const articles = computed(() => {
            return data.value?.sort((a, b) => b.date?.localeCompare(a.date || '') || 0).slice(0, 7);
        });
        return {
            articles,
        };
    },
    data() {
        return {
            NEW_CATEGORIES,
            MAP_CATS,
            CATS,
            integrations: INTEGRATIONS as IIntegration2[],
            recentIntegrations: INTEGRATIONS.slice()
                .sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''))
                .slice(0, 7),
        };
    },
};
</script>